import { RoleEnum } from 'src/api';
import { useAuth } from '../../hooks/useAuth';

const Restricted = ({ to, children }) => {
	const { userRole } = useAuth();

	if (userRole === RoleEnum.ADMIN) {
		return <>{children}</>;
	}

	if (to.includes(userRole)) {
		return <>{children}</>;
	}

	return null;
};

export default Restricted;
